import { LookupType } from "./lookups";

export const PENDING = 0;
export const ACCEPTED = 1;
export const REJECTED = 2;
export const CANCELLED = 3;
export const EXPIRED = -1;

export const InvitationStatusLookup: Array<LookupType> = [
    { value: PENDING, key: "Pending" },
    { value: ACCEPTED, key: "Accepted" },
    { value: REJECTED, key: "Rejected" },
    { value: EXPIRED, key: "Expired" }
];